module.exports = "/static/assets/ef4b2066ab53d4f2b3e8fc62709f9014.png";